export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Kontaktaufnahme',
      description:
        'Sie melden den Falschparker auf Ihrem Privatgrundstück. Wir prüfen sofort die Lage und geben direkt eine erste Einschätzung.'
    },
    {
      number: '02',
      title: 'Sofortige Anfahrt',
      description:
        'Unser Einsatzteam fährt zum Standort in Berlin, dokumentiert die Situation und bereitet alles rechtssicher vor.'
    },
    {
      number: '03',
      title: 'Abschleppen',
      description:
        'Das Fahrzeug wird professionell entfernt und zur Verwahrstelle gebracht. Schnell, sauber und nachvollziehbar.'
    },
    {
      number: '04',
      title: 'Klärung & Auskunft',
      description:
        'Auf Wunsch erhalten Sie die Einsatzdokumentation. Der Halter klärt die Auslösung direkt mit der zuständigen Stelle.'
    }
  ];

  return (
    <section id="ablauf" className="relative overflow-hidden py-24 md:py-32 bg-[#f8fbff]">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.08),transparent_38%),radial-gradient(circle_at_bottom_right,rgba(96,165,250,0.06),transparent_34%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.72),rgba(255,255,255,0.94))]" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-sky-200 bg-sky-50 px-4 py-2 text-[0.7rem] font-semibold uppercase tracking-[0.28em] text-sky-600">
            Ablauf
          </span>
          <h2 className="mt-6 text-3xl font-semibold leading-tight text-slate-900 md:text-5xl">
            So läuft Ihr Abschleppauftrag ab
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600 md:text-lg">
            Klar strukturiert, schnell umgesetzt und rechtssicher dokumentiert. Keine unnötige Laber-Optik wie jede zweite Ramsch-Abschleppseite.
          </p>
        </div>

        <div className="relative mt-16">
          <div className="hidden xl:block absolute left-0 right-0 top-9 h-px bg-gradient-to-r from-transparent via-sky-300/40 to-transparent" />

          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className="group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 hover:border-sky-300 hover:shadow-[0_20px_50px_rgba(37,99,235,0.12)]"
              >
                <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(224,242,254,0.45),transparent_35%,transparent)] opacity-80" />

                <div className="relative z-10">
                  <div className="mb-6 flex items-center gap-4">
                    <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-sky-300/20 bg-gradient-to-br from-sky-400 to-blue-600 text-base font-bold text-white shadow-[0_14px_34px_rgba(37,99,235,0.35)]">
                      {step.number}
                    </div>
                    <div className="h-px flex-1 bg-gradient-to-r from-sky-400/30 to-transparent" />
                  </div>

                  <h3 className="text-xl font-semibold leading-snug text-slate-900">
                    {step.title}
                  </h3>

                  <p className="mt-4 text-sm leading-relaxed text-slate-600 md:text-base">
                    {step.description}
                  </p>
                </div>

                {index < steps.length - 1 && (
                  <div className="xl:hidden mt-6 ml-7 h-8 w-px bg-gradient-to-b from-sky-400/25 to-transparent" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
